import { jobStates } from '@/constants/manageJobsStatus';

export function mapPayoutByStatus(jobData) {
  if (!jobData) {
    return undefined;
  }

  const { status } = jobData;

  if (status === jobStates.pending.value) {
    return jobData.priceTransporterOffered;
  }

  return jobData.priceTransporterPayout;
}
